const apiConfig = {
  appConfig: {
    apietmf: `${process.env.REACT_APP_API_ETMF}/etmf`,

    apictms: `${process.env.REACT_APP_API_CTMS}/ctms`,

    apiutils: `${process.env.REACT_APP_API_CTMS}`,

    apiutilsEtmf: `${process.env.REACT_APP_API_ETMF}`,
    
    apiisf: `${process.env.REACT_APP_API_ISF}/isf`
  }
};

export default apiConfig;
